import {
  DEFAULT_CURRENCY_SYMBOL,
  NOT_APPLICABLE_TEXT,
} from "@zenith/data/constants";
import ArrowDown from "@zenith/assets/icons/ArrowDown";
import ArrowUp from "@zenith/assets/icons/ArrowUp";
import { formatCurrency, getSuffixedNumber } from "@zenith/utils";
import { memo } from "react";

/* eslint-disable-next-line */
export interface PaymentSalesCardComponentProps {
  rate: number;
  averageSalesValue: number;
  isWeekly: boolean;
  numberOfTransactions: number;
  paymentMethod: string;
  paymentMethodSalesValue: number;
}

const PaymentSalesCardComponent = memo(function (
  props: PaymentSalesCardComponentProps
) {
  const {
    rate,
    averageSalesValue,
    isWeekly,
    numberOfTransactions,
    paymentMethod,
    paymentMethodSalesValue,
  } = props;

  return (
    <div className="flex h-60 min-w-68 flex-col items-start justify-start gap-4 rounded-lg border-1 border-zinc-300 p-4">
      <div className="flex flex-col items-start justify-start gap-1">
        <p className="text-base font-normal leading-normal text-zinc-600">
          {paymentMethod}
        </p>
        <div className="inline-flex items-end justify-start gap-1.5">
          <span className="text-lg font-normal leading-7 text-zinc-600">
            {DEFAULT_CURRENCY_SYMBOL}
          </span>
          <span className="text-xl font-medium leading-7 text-zinc-900">
            {!!paymentMethodSalesValue || paymentMethodSalesValue === 0
              ? getSuffixedNumber(paymentMethodSalesValue)
              : NOT_APPLICABLE_TEXT}
          </span>
        </div>
        <div className="flex h-6 flex-row items-center justify-start gap-1.5">
          <div
            className={`flex items-center justify-start gap-1 ${
              rate === 0 ? "" : rate > 0 ? "text-green-600" : "text-red-600"
            }`}
          >
            {rate > 0 && <ArrowUp width="9" height="12" />}
            {rate < 0 && <ArrowDown width="9" height="12" />}
            <span className="text-xs font-normal">{rate.toFixed(2)}%</span>
          </div>
          <div className="text-xs font-normal text-zinc-600">
            {isWeekly ? "Since 7 Days" : "Since 30 Days"}
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start justify-start gap-0.5">
        <span className="text-xs font-normal leading-none text-zinc-900">
          No. Transactions
        </span>
        <span className="text-xl font-medium leading-7 text-zinc-900">
          {!!numberOfTransactions || numberOfTransactions === 0
            ? numberOfTransactions
            : NOT_APPLICABLE_TEXT}
        </span>
      </div>
      <div className="flex flex-col items-start justify-start gap-0.5">
        <span className="text-xs font-normal leading-none text-zinc-900">
          Ave. Value
        </span>
        <div>
          <span className="mr-1 text-sm font-normal leading-none text-zinc-600">
            {DEFAULT_CURRENCY_SYMBOL}
          </span>
          <span className="text-base font-medium leading-normal text-zinc-900">
            {!!averageSalesValue || averageSalesValue === 0
              ? getSuffixedNumber(averageSalesValue)
              : NOT_APPLICABLE_TEXT}
          </span>
        </div>
      </div>
    </div>
  );
});

export default PaymentSalesCardComponent;
